module.exports = __webpack_public_path__ + "31692fb327b78553e930fcc6396aa3f8.svg";


//////////////////
// WEBPACK FOOTER
// ./images/archive-white.svg
// module id = 66
// module chunks = 0